import React from 'react';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import JokeBox from './JokeBox'
import {ReactComponent as LogoIcon} from '../Artboard1.svg';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  navbar: {
    border: 0,
    padding:"0px 0px 0px 10px",
    borderBottom: "1px solid #e4e4e4",
    background:"aliceblue",
  },
  navlink: {
    fontWeight: "bolder",
    letterSpacing: "1px",
  }
});


const MyNavbar = (props) => {
  const classes = useStyles();

  return (
      <Navbar className={classes.navbar} fixed="top" collapseOnSelect expand="sm">
        <Navbar.Brand href="#home" className={classes.navlink}>
          <span className={""}>
            {/*<LogoIcon style={{width:"200px", height:"42px",marginTop: "10px"}}/>*/}
            {"FittedChoice"}
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className={classes.navlink}>
            {/*<span className={"nav-link"}><Nav.Link href="#userpage">User page </Nav.Link></span>*/}
            <span className={"nav-link"}><Nav.Link href="#about">About</Nav.Link></span>
          </Nav>
          <Nav className={classes.navlink}>
            {/*<span className={"nav-link"}><Nav.Link href="#userpage">User page </Nav.Link></span>*/}
            <span className={"nav-link"}><Nav.Link href="#contact">Contact Us</Nav.Link></span>
          </Nav>
          {/*<UserMangement/>*/}
          <JokeBox/>
        </Navbar.Collapse>
      </Navbar>
);
}

export default MyNavbar;
